module.exports = __webpack_public_path__ + "static/media/help_1.e2f4d9fb.png";